/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import bus from '../bus.js';
import { mapGetters } from 'vuex';
import DownloadButton from '@/components/elements/DownloadButton.vue';
import CartButton from '@/components/elements/CartButton.vue';
import PlayImage  from '@/components/elements/PlayImage.vue';
import PauseImage  from '@/components/elements/PauseImage.vue';
import Equalizer from '@/components/elements/Equalizer.vue';

const __vue_script__ = {
	components: {
		CartButton,
		PlayImage,
		PauseImage,
		Equalizer,
		DownloadButton,
	},
	props: {
		product: Object,
		active: Boolean,
		isCurrentSong: Boolean,
	},
	data () {
		return {
			strings: ui_data.strings,
		}
	},
	computed: {
		...mapGetters([
			'getSongID',
		])	
	},
	methods: {
		updateSong( index, id ) {
			let vm = this;

			if ( this.active ) {
				bus.$emit( 'pauseSong' );
				return;
			}
			
			if ( id === this.getSongID && !this.active) {
				bus.$emit( 'resumeSong' );
				return;
			}

			//emit audiosourcelist / playlist
			bus.$emit( 'updatePlaylist', vm.audioSources);
			bus.$emit( 'updateSong', index, id );
			this.$store.commit( 'updateSongID', vm.product.id );
		},
		playSong( index, id ) {
			bus.$emit( 'resumeSong', index, id );
		},
		pauseSong( index, id ) {
			bus.$emit( 'pauseSong', index, id );
		},
		openModal( id, img, track ) {
			bus.$emit( 'showModal' );
			this.$store.commit( 'updateAddToCartTrack', track );
			setTimeout(() => {
				bus.$emit( 'updateBeatId', id );
				bus.$emit( 'updateModalPic', img );
			}, 30 );
		},
		openDownloadModal(track) {
			bus.$emit('openDownloadModal', track);
		},
	}
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"beat-row",class:{ active: _vm.active },attrs:{"itemscope":"","itemtype":"https://schema.org/MusicRecording","tabindex":"0"},on:{"click":function($event){return _vm.updateSong(_vm.product.index, _vm.product.id)}}},[_c('meta',{attrs:{"itemprop":"thumbnailUrl","content":_vm.product.image}}),_vm._v(" "),_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.product.image_tiny),expression:"product.image_tiny",arg:"background-image"}],staticClass:"beat-image"}),_vm._v(" "),(_vm.active)?_c('div',{staticClass:"eq-image"},[_c('Equalizer')],1):_vm._e(),_vm._v(" "),(_vm.active)?_c('div',{staticClass:"pause-image"},[_c('PauseImage')],1):_c('div',{staticClass:"play-image"},[_c('PlayImage')],1),_vm._v(" "),_c('div',{staticClass:"beat-title text"},[_c('router-link',{attrs:{"to":_vm.product.path},nativeOn:{"click":function($event){$event.stopPropagation();},"touchstart":function($event){$event.stopPropagation();}}},[_c('span',{attrs:{"itemprop":"name"},domProps:{"innerHTML":_vm._s(_vm.product.title)}})])],1),_vm._v(" "),_c('span',{staticClass:"sr-only",attrs:{"itemprop":"creator","itemscope":"","itemtype":"https://schema.org/Person"}},[_c('meta',{attrs:{"itemprop":"name","content":_vm.product.producer}})]),_vm._v(" "),(_vm.product.genre)?_c('div',{staticClass:"ui__genre num",attrs:{"itemprop":"genre"},domProps:{"innerHTML":_vm._s(_vm.product.genre[0])}}):_c('div',{staticClass:"ui__genre num"}),_vm._v(" "),(_vm.product.bpm)?_c('div',{staticClass:"ui__bpm num"},[_vm._v(_vm._s(_vm.product.bpm))]):_c('div',{staticClass:"ui__bpm num"}),_vm._v(" "),_c('div',{staticClass:"purchase"},[(_vm.product.free_download)?_c('button',{staticClass:"ui__beat-store-download-button px-2 text-gray-800 text-xl font-bold",attrs:{"aria-label":"Free Download","title":"Free Download"},on:{"click":function($event){$event.stopPropagation();return _vm.openDownloadModal(_vm.product)},"touchstart":function($event){$event.stopPropagation();return _vm.openDownloadModal(_vm.product)}}},[_c('svg',{staticClass:"svg-inline--fa fa-download fa-w-16 text-black",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"download","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"20","height":"20"}},[_c('path',{attrs:{"fill":"currentColor","d":"M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"}})])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn-purchase",attrs:{"title":"Buy"},on:{"click":function($event){$event.stopPropagation();return _vm.openModal( _vm.product.id, _vm.product.image_grid, _vm.product )},"touchstart":function($event){$event.stopPropagation();return _vm.openModal( _vm.product.id, _vm.product.image_grid, _vm.product )}}},[_c('span',{staticClass:"cart-btn"},[_c('CartButton')],1),_vm._v(" "),_c('span',{staticClass:"amount"},[_vm._v(_vm._s(_vm.strings["Buy"]))])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BeatRow.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__